export const SUBMIT_BASIC_FORM = "SUBMIT_BASIC_FORM";
export const SET_FORM_POSITION = "SET_FORM_POSITION";
export const SUBMIT_VENUE_FORM = "SUBMIT_VENUE_FORM";
export const SUBMIT_ACCOUNT_FORM = "SUBMIT_ACCOUNT_FORM";
export const SUBMIT_PAYMENTS_FORM = "SUBMIT_PAYMENTS_FORM";
export const SUBMIT_OPTIONS_FORM = "SUBMIT_OPTIONS_FORM";
export const SUBMIT_BUSINESS_FORM = "SUBMIT_BUSINESS_FORM";
export const SET_IS_LOADING = "SET_IS_LOADING";
export const SET_LEADID = "SET_LEADID";

export const SET_VENUE_DATA = "SET_VENUE_DATA";

export const MODAL_OPEN = "MODAL_OPEN";
export const MODAL_CLOSE = "MODAL_CLOSE";
export const MODAL_SET = "MODAL_SET";

export const SET_DIALOG_HANDLE = "SET_DIALOG_HANDLE";
export const SET_DIALOG_HANDLE_IS_OPEN = "SET_DIALOG_HANDLE_IS_OPEN";
export const SET_CAN_CLOSE_DIALOG = "SET_CAN_CLOSE_DIALOG";
export const SET_DIALOG_TITLE = "SET_DIALOG_TITLE";
export const SET_DIALOG_CHANGED = "SET_DIALOG_CHANGED";
export const SET_MULTI_DIALOG_CHANGED = "SET_MULTI_DIALOG_CHANGED";

export const SIDEBAR_SET = "SIDEBAR_SET";
export const GENERAL_SET = "GENERAL_SET";

export const OUTSTANDING_SWITCH = "OUTSTANDING_SWITCH";

export const MD_LANGUAGE_SET = "MD_LANGUAGE_SET";

export const SET_PAYMENT_ERROR = "SET_PAYMENT_ERROR";
export const SET_PAYMENT_URL = "SET_PAYMENT_URL";
export const SET_PAYMENT_STAGE = "SET_PAYMENT_STAGE";
export const SET_PAYMENTS_DETAILS = "SET_PAYMENTS_DETAILS";

export const TIPPING_MASTER_ENABLED = "TIPPING_MASTER_ENABLED";
export const SET_CURRENT_ENABLED_TIPS = "SET_CURRENT_ENABLED_TIPS";
export const SET_ORIGINAL_ENABLED_TIPS = "SET_ORIGINAL_ENABLED_TIPS";
export const SET_INVALID_TIP = "SET_INVALID_TIP";
export const RESET_TIPPING = "RESET_TIPPING";



export const SET_OPEN_BANKING_SECURE_KEY = "OPEN_BANKING_SECURE_KEY";


